import * as HTTP from "./http";
import { IRack, IRackOutplantingPrediction } from "@/types/data";
import { IListApiReponse } from "@/types/api";
import { DeviceOfflineError } from "@/errors";

export function getRacks(nurseryId: string, tankId: string): Promise<IListApiReponse<IRack>> {
  return HTTP.get(`/api/v1/nurseries/${nurseryId}/racks/?tank=${tankId}`)
    .then(r => {
      if (!r.ok) throw new Error("Unable to get racks.");
      return r.json();
    });
}

export function getRack(nurseryId: string, rackId: string): Promise<IRack> {
  return HTTP.get(`/api/v1/nurseries/${nurseryId}/racks/${rackId}/`)
    .then(r => {
      if (!r.ok) throw new Error("Rack not found.");
      return r.json();
    });
}

export function getRackOutplantingPrediction(nurseryId: string, rackId: string): Promise<IRackOutplantingPrediction> {
  return HTTP.get(`/api/v1/nurseries/${nurseryId}/racks/${rackId}/outplanting/`)
    .then(async (r) => {
      if (!r.ok) {
        const data = await r.json();
        throw new Error(data.error);
      }
      return r.json();
    });
}

export function uploadRackImage(image: File) {
  const headers = new Headers({});
  const token = localStorage.getItem("token");
  if (token) {
    headers.set("Authorization", `Token ${token}`);
  }

  const formData = new FormData();
  formData.append("file", image);
  formData.append("name", image.name);

  return fetch(`${import.meta.env.VITE_API_HOST}/api/v1/file-upload/`, {
    method: "POST",
    body: formData,
    headers
  })
    .then(r => {
      if (r.status === 599) {
        throw new DeviceOfflineError();
      }
      if (!r.ok) throw new Error("Unable to upload file.");
      return r.json();
    });
}
